import {
  getAdvancingBagdeStyle,
  getCurrencySymbol,
  getDaysString,
  getPositiveSum,
} from '../../../../helpers';
import moment from 'moment';
import React, { useState } from 'react';
import styled from '@emotion/styled';
import { useAutoTranslation } from '../../../../helpers/useAutoTranslation';

const Badge = styled('div')`
  position: relative;
  span {
    cursor: pointer;
    display: inline-block;
    padding: 1px 5px;
    border-radius: 4px;
  }
`;

const BadgeTipWrap = styled('div')`
  position: absolute;
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  padding: 12px;
  width: 264px;
  top: 33px;
  z-index: 1;

  .dates-block {
    display: flex;
    margin: 0 -6px;
    justify-content: space-between;
    div {
      padding: 0 6px;
    }
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0 0 0 5px;
    li {
      position: relative;
      font-size: 14px;
      font-weight: 500;
      &::before {
        content: '';
        position: absolute;
        width: 6px;
        height: 6px;
        background: #f1556c;
        border-radius: 6px;
        top: 7px;
        left: -4px;
      }
      &.yellow::before {
        background: #f7b84b;
      }
      &.blue::before {
        background: rgb(79, 198, 225);
      }
    }
  }
`;

const BadgeTip = (props) => {
  const { item } = props;

  if (item.status === 'AWAITING_PAYMENT' || item.status === 'PARTIALLY_PAID') {
    return (
      <BadgeTipWrap>
        <ul>
          <li className={(item.status === 'AWAITING_PAYMENT' ? 'yellow' : 'blue') + ' mb-2'}>
            <span className="dot-marker"></span>
            Осталось оплатить: {`${getPositiveSum(item.balanceSum)} ${getCurrencySymbol('RUB')}`}
          </li>
        </ul>
        <div className="dates-block">
          <div>
            <small style={{ display: 'block' }} className="text-muted mb-1">
              Счет выставлен
            </small>
            <small className="font-weight-bolder">{moment(item.date).format('DD.MM.YYYY')}</small>
          </div>
          {item.deadline && (
            <div>
              <small style={{ display: 'block' }} className="text-muted mb-1">
                Крайний срок оплаты
              </small>
              <small className="font-weight-bolder">
                {moment(item.deadline).format('DD.MM.YYYY')}
              </small>
            </div>
          )}
        </div>
      </BadgeTipWrap>
    );
  }

  if (item.status === 'EXPIRED') {
    return (
      <BadgeTipWrap>
        <ul>
          <li className="mb-2">
            <span className="dot-marker"></span>
            Просрочен на {moment(item.deadline).diff(moment(new Date()), 'days')}{' '}
            {getDaysString(moment(item.deadline).diff(moment(new Date()), 'days'))}
          </li>
          <li className="mb-2">
            <span className="dot-marker"></span>
            Осталось оплатить: {`${getPositiveSum(item.balanceSum)} ${getCurrencySymbol('RUB')}`}
          </li>
        </ul>
        <div className="dates-block">
          <div>
            <small style={{ display: 'block' }} className="text-muted mb-1">
              Счет выставлен
            </small>
            <small className="font-weight-bolder">{moment(item.date).format('DD.MM.YYYY')}</small>
          </div>
          <div>
            <small style={{ display: 'block' }} className="text-muted mb-1">
              Крайний срок оплаты
            </small>
            <small className="font-weight-bolder">
              {moment(item.deadline).format('DD.MM.YYYY')}
            </small>
          </div>
        </div>
      </BadgeTipWrap>
    );
  }
  return <div></div>;
};

const PaymentBadge = (props) => {
  const { item } = props;
  const { title, style } = getAdvancingBagdeStyle(item);

  const [showTip, setShowTip] = useState(false);

  const { t } = useAutoTranslation();

  return (
    <Badge>
      <span style={style} onMouseOver={() => setShowTip(true)} onMouseOut={() => setShowTip(false)}>
        {t(title)}
      </span>
      {showTip && <BadgeTip item={item} />}
    </Badge>
  );
};

export default PaymentBadge;
